/**
 * The items as small filled SVG glyphs: the resources (a log end, a pebble, a gem) and the blocks
 * (a cube in its material's colours, plan 29). Pure data for the HUD and the world's badges.
 */

/** A cube seen from above and the front: a light top, a left and a right face. */
const cube = (top: string, left: string, right: string): string =>
  `<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" fill="${left}"/><path d="M12 12l8-4.5v9L12 21z" fill="${right}"/><path d="M12 3l8 4.5-8 4.5-8-4.5z" fill="${top}"/>`;

export const RESOURCE_GLYPHS: Readonly<Record<string, string>> = {
  wood: '<circle cx="12" cy="12" r="9.5" fill="#A97C50"/><circle cx="12" cy="12" r="6.6" fill="#D9B98A"/><circle cx="12" cy="12" r="3.6" fill="#B98C5C"/><circle cx="12" cy="12" r="1.3" fill="#7A5638"/>',
  stone:
    '<path d="M3.5 14.5c0-5.2 3.9-9 9.2-9s8.3 3 8.3 7.2-3.4 6.3-8.6 6.3-8.9-1.1-8.9-4.5z" fill="#9AA3B0"/><ellipse cx="9.5" cy="10" rx="3" ry="1.7" fill="#C8CFD9"/>',
  crystal:
    '<path d="M12 2.5l7.5 7.5L12 21.5 4.5 10z" fill="#9E7FE0"/><path d="M12 2.5l7.5 7.5h-15z" fill="#C9B6F3"/><path d="M12 2.5L9 10h6z" fill="#E6DCFA"/>',
  'soil-block': cube('#B08E62', '#8E6B48', '#6F5438'),
  'stone-block': cube('#DCE3EC', '#B9C6D6', '#94A2B4'),
  'ore-block':
    cube('#7D7398', '#5E5870', '#48435A') +
    '<path d="M9 13.5l1.6-3.2 1.6 3.2z" fill="#C9B6F3"/><path d="M13.5 15.5l1.2-2.4 1.2 2.4z" fill="#9E7FE0"/>',
  'basalt-block': cube('#5E6775', '#4A5261', '#373D49'),
  'gold-block': cube('#F4D56A', '#D8AE3C', '#B38A27'),
};
